<template>
  <div class="day-wrapper">
    <div class="day" v-for="(d, i) in Array(18)" :key="i">
      <div class="day-inner flx-25" v-for="(inner, i) in Array(4)" :key="'day-inner-i'+i"></div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Day extends Vue {}
</script>

<style lang="stylus" scoped>
.day-wrapper {
  display: flex;
  flex-direction: column;

  .day {
    display: flex;
    flex-direction: column
    border: 1px solid #000;
    height: 32px;

    .day-inner {
      border: 1px solid blue
    }
  }
}
</style>